(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-rich-text-read-more]');

    roots.forEach(function (root) {
      var content = root.querySelector('.rich-text__read-more-content');
      var button = root.querySelector('.rich-text__read-more-toggle');

      if (!content || !button) {
        return;
      }

      var previewHeight = parseInt(
        window.getComputedStyle(content).getPropertyValue('--read-more-preview-height'),
        10
      );

      if (!previewHeight || content.scrollHeight <= previewHeight + 8) {
        return;
      }

      root.classList.add('is-collapsible');
      button.hidden = false;

      button.addEventListener('click', function () {
        var isExpanded = root.classList.toggle('is-expanded');
        var moreLabel = button.querySelector('[data-read-more-label]');
        var lessLabel = button.querySelector('[data-read-less-label]');

        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        if (moreLabel) {
          moreLabel.hidden = isExpanded;
        }

        if (lessLabel) {
          lessLabel.hidden = !isExpanded;
        }

        if (!isExpanded) {
          var section = root.closest('[data-section-type="rich-text"]') || root;
          var top = section.getBoundingClientRect().top + window.pageYOffset - 120;

          window.setTimeout(function () {
            window.scrollTo({
              top: Math.max(top, 0),
              behavior: 'smooth'
            });
          }, 0);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nw-slide-media')) {
    customElements.define('nw-slide-media', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const slide = this.closest('.slideshow-slide');
        if (!slide) return;

        this.slide = slide;
        this.ui = slide.querySelector('[data-slide-media-ui]');
        this.frames = Array.from(this.querySelectorAll('.nw-slide-media__frame'));
        if (!this.frames.length) return;

        this.frames.forEach(frame => frame.style.removeProperty('opacity'));
        this.index = Math.max(0, this.frames.findIndex(frame => frame.classList.contains('is-active')));
        this.randomRemaining = this.frames.map((_, index) => index).filter(index => index !== this.index);
        this.busy = false;
        this.focused = false;
        this.arrowsHovered = false;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots = this.ui ? Array.from(this.ui.querySelectorAll('[data-media-index]')) : [];

        const imageArea = this.closest('.slideshow-slide__image-container');
        const updateImageSizes = () => {
          this.querySelectorAll('img[width][height][srcset]').forEach(image => {
            const width = image.clientWidth;
            const height = image.clientHeight;
            const ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
            if (!width || !height || !Number.isFinite(ratio) || ratio <= 0) return;
            const fit = getComputedStyle(image).objectFit;
            const effectiveWidth = fit === 'cover' ? Math.max(width, height * ratio) : width;
            image.sizes = `${Math.ceil(effectiveWidth)}px`;
          });
        };
        this.imageSizeObserver?.disconnect();
        if (imageArea && 'ResizeObserver' in window) {
          this.imageSizeObserver = new ResizeObserver(updateImageSizes);
          this.imageSizeObserver.observe(imageArea);
          updateImageSizes();
        }

        const hoverArrows = this.ui?.querySelector('[data-step]') && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (hoverArrows) {
          this.arrowsHovered = slide.matches(':hover');
          slide.addEventListener('mouseenter', () => {
            clearTimeout(this.arrowExitTimer);
            this.arrowsHovered = true;
            this.schedule();
          }, options);
          slide.addEventListener('mouseleave', () => {
            clearTimeout(this.arrowExitTimer);
            this.arrowExitTimer = setTimeout(() => {
              this.arrowsHovered = false;
              this.schedule();
            }, 220);
          }, options);
        }

        this.ui?.querySelectorAll('[data-step]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.change(Number(button.dataset.step));
          }, options);
        });

        const dotNavigation = this.ui?.querySelector('.nw-slide-media__dots');
        if (dotNavigation) dotNavigation.hidden = false;
        this.dots.forEach(button => button.addEventListener('click', async event => {
          event.preventDefault();
          event.stopPropagation();
          await this.change(0, false, Number(button.dataset.mediaIndex));
          this.schedule();
        }, options));

        slide.addEventListener('focusin', () => {
          this.focused = slide.matches(':has(:focus-visible)');
          this.schedule();
        }, options);
        slide.addEventListener('focusout', event => {
          this.focused = !!(event.relatedTarget && slide.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'));
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => {
          this.syncVideos();
          this.schedule();
        }, options);

        this.inertObserver?.disconnect();
        this.inertObserver = new MutationObserver(() => {
          this.syncVideos();
          this.schedule();
        });
        this.inertObserver.observe(slide, { attributes: true, attributeFilter: ['inert'] });

        this.syncVideos();
        this.schedule();
      }

      slideIsActive() {
        return !this.slide?.hasAttribute('inert');
      }

      syncVideos() {
        const playing = this.slideIsActive() && !this.paused && !document.hidden;
        this.frames.forEach((frame, index) => {
          frame.querySelectorAll('video').forEach(video => {
            video.muted = true;
            video.playsInline = true;
            if (playing && index === this.index) {
              const playAttempt = video.play();
              if (playAttempt) playAttempt.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.frames.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.arrowsHovered || this.focused || document.hidden || !this.slideIsActive() || !this.isConnected) return;
        this.timer = setTimeout(async () => {
          await this.change(1, true);
          this.schedule();
        }, Math.max(1, Math.min(10, Number(this.dataset.speed) || 3)) * 1000);
      }

      async change(step, automatic = false, targetIndex = null) {
        if (this.busy || this.frames.length < 2 || targetIndex === this.index) return;
        this.busy = true;
        const signal = this.controller.signal;
        const random = automatic && this.dataset.randomOrder === 'true';
        let next = targetIndex === null ? (this.index + step + this.frames.length) % this.frames.length : targetIndex;
        if (random) {
          if (!this.randomRemaining.length) this.randomRemaining = this.frames.map((_, index) => index);
          const candidates = this.randomRemaining.filter(index => index !== this.index);
          if (!candidates.length) {
            this.busy = false;
            return;
          }
          next = candidates[Math.floor(Math.random() * candidates.length)];
        }
        const images = Array.from(this.frames[next].querySelectorAll('img')).filter(image => !image.closest('video'));
        try {
          await Promise.all(images.map(image => {
            image.loading = 'eager';
            return image.decode ? image.decode() : Promise.resolve();
          }));
          if (signal.aborted || !this.isConnected) return;
          if (automatic && (this.arrowsHovered || this.focused || this.paused || document.hidden || !this.slideIsActive())) return;
          const previous = this.index;
          this.frames[previous].classList.remove('is-active');
          this.frames[previous].setAttribute('aria-hidden', 'true');
          this.frames[previous].setAttribute('inert', '');
          this.frames[next].classList.add('is-active');
          this.frames[next].setAttribute('aria-hidden', 'false');
          this.frames[next].removeAttribute('inert');
          this.index = next;
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
          this.syncVideos();
          if (random) this.randomRemaining.splice(this.randomRemaining.indexOf(next), 1);
          else this.randomRemaining = this.frames.map((_, index) => index).filter(index => index !== next);
        } catch {
          return;
        } finally {
          if (!signal.aborted) this.busy = false;
        }
      }

      disconnectedCallback() {
        this.imageSizeObserver?.disconnect();
        this.inertObserver?.disconnect();
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.arrowExitTimer);
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    });
  }

  if (!window.nwSlideshowStaticBound) {
    window.nwSlideshowStaticBound = true;
    const colorVars = ['--color-text', '--color-text-link', '--color-text-overlay-button', '--color-text-overlay-button-alpha', '--color-background-overlay-button', '--color-background-overlay-button-hover', '--color-background-overlay-button-alpha', '--color-background-overlay-outline-button-alpha'];
    const bindStaticContent = (slideshow) => {
      const layer = slideshow.querySelector('.slideshow__static-content');
      if (!layer || slideshow.dataset.staticBound === 'true') return;
      slideshow.dataset.staticBound = 'true';
      const fadeMs = parseInt(slideshow.dataset.fadeDuration, 10) || 2000;
      const buttonFade = 800;
      slideshow.style.setProperty('--slideshow-fade-duration', fadeMs + 'ms');
      slideshow.style.setProperty('--slideshow-button-fade', buttonFade + 'ms');
      const row = layer.querySelector('.slideshow-slide__buttons-wrapper');
      let shownId = null;
      let pendingId = null;
      let fadeTimer = null;
      const applyButtons = (id) => {
        layer.querySelectorAll('[data-static-button]').forEach((node) => {
          node.classList.toggle('is-active', node.getAttribute('data-static-button') === id);
        });
        layer.querySelectorAll('.slideshow__static-button-slot').forEach((slot) => {
          const hasActive = slot.querySelector('.slideshow__static-button.is-active');
          clearTimeout(slot._emptyTimer);
          if (hasActive) {
            slot.hidden = false;
          } else if (slideshow.classList.contains('slideshow--buttons-ready')) {
            slot._emptyTimer = setTimeout(() => {
              if (!slot.querySelector('.slideshow__static-button.is-active')) slot.hidden = true;
            }, fadeMs);
          } else {
            slot.hidden = true;
          }
        });
      };
      const sync = () => {
        const active = slideshow.querySelector('.swiper-slide-active:not(.swiper-slide-duplicate)') || slideshow.querySelector('.swiper-slide-active') || slideshow.querySelector('.slideshow-slide');
        if (!active) return;
        const id = active.getAttribute('data-slide');
        colorVars.forEach((name) => {
          const value = active.style.getPropertyValue(name);
          if (value) layer.style.setProperty(name, value.trim());
        });
        if (!id) return;
        if (!row || shownId === null || !slideshow.classList.contains('slideshow--buttons-ready')) {
          shownId = id;
          pendingId = null;
          applyButtons(id);
          if (row) row.style.opacity = '1';
          return;
        }
        if (id === shownId && !pendingId) return;
        if (id === pendingId) return;
        pendingId = id;
        row.style.opacity = '0';
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(() => {
          const next = pendingId;
          pendingId = null;
          if (!next) return;
          shownId = next;
          applyButtons(next);
          row.style.transition = 'none';
          row.style.opacity = '1';
          row.style.transform = 'none';
          const slots = row.querySelectorAll(':scope > .slideshow__static-button-slot, :scope > .section-blocks__button');
          slots.forEach((slot, index) => {
            slot.style.transition = 'none';
            slot.style.opacity = '0.5';
            slot.style.transform = index === 0 ? 'translate3d(-14px, 0, 0)' : 'translate3d(14px, 0, 0)';
          });
          void row.offsetWidth;
          slots.forEach((slot) => {
            slot.style.transition = '';
            slot.style.opacity = '1';
            slot.style.transform = 'translate3d(0, 0, 0)';
          });
          row.style.transition = '';
        }, buttonFade);
      };
      const carousel = slideshow.querySelector('[data-slideshow]');
      if (carousel) {
        new MutationObserver(sync).observe(carousel, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      sync();
      requestAnimationFrame(() => slideshow.classList.add('slideshow--buttons-ready'));
    };
    const bootStaticContent = (root) => {
      (root || document).querySelectorAll('.slideshow').forEach(bindStaticContent);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootStaticContent());
    } else {
      bootStaticContent();
    }
    document.addEventListener('shopify:section:load', (event) => bootStaticContent(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
